const interfaceTranslations = {
  "selectedCountryAriaLabel": "Valittu maa",
  "noCountrySelected": "Maata ei ole valittu",
  "countryListAriaLabel": "Luettelo maista",
  "searchPlaceholder": "Haku",
  "zeroSearchResults": "Ei tuloksia",
  "oneSearchResult": "1 tulos löytyi",
  "multipleSearchResults": "${count} tulosta löytyi",
  // additional countries (not supported by country-list library)
  "ac": "Ascension",
  "xk": "Kosovo"
};
export default interfaceTranslations;
